import { FC, useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { dateFns, isArray, isNotEmpty, isNotEmptyAny } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import SpotFlowCard from '@/common/components/business/DynamicComponent/components/PassengerFlow/SpotFlowCard';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import { PASSENGER_FLOW_MODE, PASSENGER_FLOW_SPOTS, PASSENGER_FLOW_WEEKDAY, PASSENGER_FLOW_WEEKEND, SPOTS_ANALYSIS_MAP } from '@/common/components/business/DynamicComponent/components/PassengerFlow/config';
import styles from './index.module.less';
import { getTaskAnalysisList } from '@/common/api/expandStore/chancepoint';
import V2Title from '@/common/components/Feedback/V2Title';

/**
 * @Description 客流计数模块
 *
 * 参照动态表单-客流计数属性类型的详情实现
 * src/common/components/business/StoreDetail/components/DynamicDetail/components/PassengerFlowCountingDetail.tsx
 */
const RelationCheckPoints: FC<{
  checkSpots: Array<{id: number, name: string}>
}> = ({
  checkSpots
}) => {
  const [spotsList, setSpotsList] = useState<any>([]); // 客流点位信息列表
  const [weekdayCount, setWeekdayCount] = useState<any>(null);
  const [weekendCount, setWeekendCount] = useState<any>(null);

  useEffect(() => {
    methods.handleSpotsChange(checkSpots);
  }, [checkSpots]);

  const methods = useMethods({
    /** 点位选择变化 */
    handleSpotsChange(spots: Array<{id: number, name: string}>) {
      if (!isNotEmptyAny(spots)) {
        setSpotsList([]);
        setWeekdayCount(null);
        setWeekendCount(null);
        return;
      }
      getTaskAnalysisList({
        taskAnaStatus: SPOTS_ANALYSIS_MAP.ANALYSISED,
        ids: spots.map(itm => itm.id)
      }).then((res) => {
        setSpotsList(res || []);
        this.getCountBySpots(res || []);
      });
    },

    /** 获取所选点位最高周中客流和周末客流 */
    getCountBySpots(list) {
      let allDataArr: any = [];

      list?.forEach((item: any) => {
        allDataArr = allDataArr.concat(item.deviceTaskAnalysisList);
      });

      const weekdayArr: any = [];
      const weekendArr: any = [];

      allDataArr.forEach((item) => {
        dateFns.getIsWeekend(item.date) ? weekendArr.push(item) : weekdayArr.push(item);
      });

      const weekdayMaxCount = weekdayArr.length ? Math.max(...weekdayArr?.map((item) => item.passbyCount)) : 0;
      const weekendMaxCount = weekendArr.length ? Math.max(...weekendArr?.map((item) => item.passbyCount)) : 0;

      setWeekdayCount(weekdayMaxCount);
      setWeekendCount(weekendMaxCount);
    },
  });

  return (
    <>
      <V2Title
        type='H2'
        divider
        text={'客流计数'}
        className={'pt-16'}
      />
      <Row gutter={24}>
        <Col span={12}>
          <V2DetailItem label={PASSENGER_FLOW_MODE.label} value={'设备采集'}/>
        </Col>
        <>
          <Col span={12}>
            <V2DetailItem
              label={PASSENGER_FLOW_SPOTS.label}
              value={checkSpots?.map((item) => item.name)?.join('、')}/>
          </Col>
          <Col span={24}>
            <div className={styles.spotFlowList}>
              {isArray(spotsList) && spotsList.length ? spotsList.map((item, index) => (
                <SpotFlowCard key={index} itemData={item}/>
              )) : <></>}
            </div>
          </Col>
        </>
        <Col span={12}>
          <V2DetailItem
            label={PASSENGER_FLOW_WEEKDAY.label}
            value={isNotEmpty(weekdayCount) ? weekdayCount + '人' : '-'}/>
        </Col>
        <Col span={12}>
          <V2DetailItem
            label={PASSENGER_FLOW_WEEKEND.label}
            value={isNotEmpty(weekendCount) ? weekendCount + '人' : '-'}/>
        </Col>
      </Row>
    </>
  );
};

export default RelationCheckPoints;
